import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layout/Layout.vue';

import UserLogin from '@/views/UserLogin.vue';

import ReceiptsList from '@/views/ReceiptsList.vue';
import CheckDetail from '@/views/CheckReceiptDetail.vue';

import ManualBuild from '@/views/ManualBuildReceipt.vue';
import ManualBuildStepFirst from '@/views/ManualBuildReceipt/StepFirst.vue';
import ManualBuildStepSecond from '@/views/ManualBuildReceipt/stepSecond.vue';

import ModelBuild from '@/views/ModelBuildReceipt.vue';

import ModifyPass from '@/views/ModifyPass.vue';
import TemplateDownload from '@/views/TemplateDownload.vue';

import SalesStatistics from '@/views/SalesStatistics.vue';
import DeclareMaterials from '@/views/declare/index.vue';
import DeclareMaterialsCreate from '@/views/declare/create.vue';
import DeclareaddSpc from '@/views/declare/addSpc.vue';
import MaterialsReview from '@/views/review/index.vue';

import DraftList from '@/views/draftList.vue';
import PlanList from '@/views/plan/index.vue';
import PlanDetail from '@/views/plan/detail.vue';
import MaterialsRecord from '@/views/declare/record.vue';
import MaterialsRecordModify from '@/views/declare/recordModify.vue';
import SupplierList from '@/views/supplier/index.vue';
import AddSupplier from '@/views/supplier/add/index.vue';
import MetarialsManages from '@/views/metarilas/index.vue';

import PlanPrice from '@/views/PlanPrice/index.vue';
import PlanPriceDetail from '@/views/PlanPrice/detail.vue';
import MaterialsPrice from '@/views/materialsPrice/index.vue';
import MaterialsTemplateCreate from '@/views/materialsPrice/TemplateCreate.vue';
import MaterialsPriceDetail from '@/views/materialsPrice/OrderDetail.vue';
import materialsIndepend from '@/views/materialsIndepend/index.vue';

import MaterialsSales from '@/views/summary/MaterialSales.vue';

Vue.use(Router);

export default new Router({
    routes: [{
        path: '/',
        name: 'userLogin',
        component: UserLogin
    }, {
        path: '/index',
        component: Layout,
        redirect: {
            name: 'receiptsList'
        },
        children: [

            // 单据列表
            {
                path: 'receiptsList',
                name: 'receiptsList',
                component: ReceiptsList,
                meta: {
                    requireAuth: true
                }
            },

            // 查看单据详情
            {
                path: 'checkDetail',
                name: 'checkDetail',
                component: CheckDetail,
                meta: {
                    requireAuth: true
                }
            },
            // 手动新建单据
            {
                path: 'manualBuild',
                component: ManualBuild,
                children: [
                    {
                        path: '',
                        name: 'stepFirst',
                        component: ManualBuildStepFirst,
                        meta: {
                            requireAuth: true
                        }
                    },
                    {
                        path: 'stepSecond',
                        name: 'stepSecond',
                        component: ManualBuildStepSecond,
                        meta: {
                            requireAuth: true
                        }
                    }
                ]
            },

            // 模板新建单据
            {
                path: 'modelBuild',
                name: 'modelBuild',
                component: ModelBuild,
                meta: {
                    requireAuth: true
                }
            },

            // 模板下载
            {
                path: 'modifyPass',
                name: 'modifyPass',
                component: ModifyPass,
                meta: {
                    requireAuth: true
                }
            },

            // 修改密码
            {
                path: 'templateDownload',
                name: 'templateDownload',
                component: TemplateDownload,
                meta: {
                    requireAuth: true
                }
            },

            // 销售统计
            {
                path: 'sales-statistics',
                name: 'salesStatistics',
                component: SalesStatistics,
                meta: {
                    requireAuth: true
                }
            },
            // 申报新物资
            {
                path: 'declare',
                name: 'declare',
                component: DeclareMaterials,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'declare-create',
                name: 'declare-create',
                component: DeclareMaterialsCreate,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'addSpec',
                name: 'add-spec',
                component: DeclareaddSpc,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'review',
                name: 'review',
                component: MaterialsReview,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'declare-record',
                name: 'record',
                component: MaterialsRecord,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'record-modify',
                name: 'record-modify',
                component: MaterialsRecordModify,
                meta: {
                    requireAuth: true
                }
            },
            // 草稿箱
            {
                path: 'draft',
                name: 'draft',
                component: DraftList,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'plan',
                name: 'plan',
                component: PlanList,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'planDetail',
                name: 'planDetail',
                component: PlanDetail,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'supplier',
                name: 'supplier',
                component: SupplierList,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'supplier/add',
                name: 'supplierAdd',
                component: AddSupplier,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'metarials',
                name: 'metarials',
                component: MetarialsManages,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'plan_price',
                name: 'plan-price',
                component: PlanPrice,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'plan_price/detail',
                name: 'plan-price-detail',
                component: PlanPriceDetail,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'materials-price',
                name: 'materials-price',
                component: MaterialsPrice,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'materials-price/create',
                name: 'materials-price-create',
                component: MaterialsTemplateCreate,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'materials-price/detail',
                name: 'materials-price-detail',
                component: MaterialsPriceDetail,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'materials-independ',
                name: 'materials-independ',
                component: materialsIndepend,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'materialsSales',
                name: 'materials-sales',
                component: MaterialsSales,
                meta: {
                    requireAuth: true
                }
            }
        ]
    }]
});



// WEBPACK FOOTER //
// ./src/router/index.js